import * as panelActions from "../actions/panelActions";
import {updateObject} from "../../utils/util";
import produce from "immer";

const initialState = {
  beneficiariesLoaded: false,
  credentialSVG: null,
  receiptPaymentSVG: null,
  errorVersion: false,
  minVersion: "",
  lastVersion: "",
  currVersion: "",
  app: false
};

export function panelReducer(state = initialState, action) {
  switch (action.type) {
    case panelActions.BENEFICIARIES_LOADED:
      return updateObject(state, { ...action.panel });
    case panelActions.CLEAR_PANEL:
      return initialState;
    case panelActions.ADD_CREDENTIAL_SVG:
      return produce(state, drafState => {
        drafState.credentialSVG = action.credential;
      });
    case panelActions.ADD_RECEIPT_PAYMENT_SVG:
      return produce(state, drafState => {
        drafState.receiptPaymentSVG = action.receipt;
      });
    case panelActions.ERROR_VERSION_MINIMA:
      return updateObject(state, { ...action.panel });
    case panelActions.ADD_MIN_VERSION:
      return updateObject(state, { ...action.panel });
    case panelActions.ADD_LAST_VERSION:
      return updateObject(state, { ...action.panel });
    case panelActions.ADD_CURR_VERSION:
      return updateObject(state, { ...action.panel });
    case panelActions.APP_MOBILE:
      return updateObject(state, { ...action.panel });
    default:
      return state;
  }
}